import { Pipe, PipeTransform } from '@angular/core';
import { toPlatformCurrency } from '../utils/platform-currency';

@Pipe({ name: 'platformCurrency' })
export class PlatformCurrencyPipe implements PipeTransform {
  /**
   * 廠商幣種轉為對應的平台幣種（如 USD → USDT），見 PROVIDER_TO_PLATFORM_CURRENCY
   *
   * @param val
   */
  transform(val: string): string {
    return toPlatformCurrency(val);
  }
}
